import { queryOptions } from '@tanstack/vue-query'
import merge from 'lodash/merge'
import { queryClient } from '@/plugins/tanstack'
import { getSpaces } from '@/common/services/SpaceService'
import localizationServerData from '@/common/services/serverData/localizationServerData'
import { invalidateQuery, queryKeyFactory } from '@/common/services/serverData/serverDataManager'
import { SERVER_DATA_LABELS, SERVER_DATA_SCOPE, type GroupOptionsBase } from '@/common/types/cacheConstants'

function groupOptions(options: GroupOptionsBase = {}) {
  const defaultConfig = {
    queryKey: queryKeyFactory({
      scope: SERVER_DATA_SCOPE.SPACES,
    }),
    staleTime: Infinity,
    queryFn: getSpaces,
  }
  return queryOptions(merge(defaultConfig, options))
}

async function fetch(options: GroupOptionsBase = {}) {
  const { staleTime } = options
  const [result] = await Promise.all([
    queryClient.fetchQuery(groupOptions(options)),
    localizationServerData.fetch({
      prefixes: SERVER_DATA_LABELS.SPACES,
      staleTime,
    }),
  ])
  return result
}

function invalidate() {
  invalidateQuery([
    queryKeyFactory({
      scope: SERVER_DATA_SCOPE.SPACES,
    }),
  ])
}

export default {
  fetch,
  groupOptions,
  invalidate,
}
